import { render, staticRenderFns } from "./ChatbotPromptEdit.vue?vue&type=template&id=46ef3cfd"
import script from "./ChatbotPromptEdit.vue?vue&type=script&lang=js"
export * from "./ChatbotPromptEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports